import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../eventTriggers'
import moment from 'moment'

export function Tests() {
  const { medical_tests } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'tests'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "test",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        medical_tests.map(test=>(
          <div key={test.id} onClick={()=>handleClick(test)} className="p-4 border-bottom clickable d-flex justify-content-between">
            <div>
              <b>{test.kind}</b>
              <div>{ test.performed_on ? moment(test.performed_on).format('MM/DD/YYYY') : null}</div>
            </div>
            <div>
              <div className={`badge badge-${test.result == 'positive' ? 'danger' : 'success'} text-capitalize`}>{test.result}</div>
            </div>
          </div>
        ))
      }
    </div>
  )
}
